import { ReactElement, useEffect, useState } from 'react';
import {
	UpdateArcOperatorForm,
	UpdateArcOperatorFormData
} from '../update-arc-operator-form';
import { useOpenApi } from '../../../core/providers';
import { parseApiError } from '@techshift/react-core';
import { AppToaster } from '../../../core/util';
import { ArcOperator } from '@techshift/callie-private-api-typescript';

export type UpdateArcOperatorProps = {
	operator: ArcOperator;
	onSuccess?: (operator: ArcOperator) => void;
};
export function UpdateArcOperator(props: UpdateArcOperatorProps): ReactElement {
	const { operator, onSuccess } = props;

	const { openApi } = useOpenApi();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		if (error) {
			AppToaster.show({ message: error, intent: 'danger' });
		}
	}, [error]);

	const onSubmit = ({
		firstName,
		lastName,
		email
	}: UpdateArcOperatorFormData) => {
		setLoading(true);
		setError('');
		openApi.arc
			.updateArcOperator(operator.id, { firstName, lastName, email })
			.then((response) => {
				AppToaster.show({ message: 'Arc operator updated', intent: 'success' });
				onSuccess?.(response.data.data.operator);
			})
			.catch((error) => {
				parseApiError({
					error,
					unknownError: () => {
						setError('Unknown error');
					},
					requestError: () => {
						setError('Unable to reach server');
					},
					responseError: ({ response }) => {
						if (response.data.message === 'OPERATOR_ALREADY_EXISTS') {
							setError('ARc operator with this email already exists');
						} else {
							setError('Unknown error');
						}
					}
				});
			})
			.finally(() => setLoading(false));
	};
	return (
		<UpdateArcOperatorForm
			initialFirstName={operator.firstName}
			initialLastName={operator.lastName}
			initialEmail={operator.email}
			loading={loading}
			onSubmit={onSubmit}
		/>
	);
}
